import { render, staticRenderFns } from "./YasakView.vue?vue&type=template&id=6322567c"
import script from "./YasakView.vue?vue&type=script&lang=ts"
export * from "./YasakView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports